import { useSignupPage, signupErrorReason } from 'utils/signupAnalytics';
import { localStorage as safeLocalStorage } from 'utils/browserStorage';
import React, {useEffect, useRef, useState} from 'react'
import {useHistory, useLocation} from 'react-router';
import * as ls from "utils/localStorage";
import _ from 'lodash'
import {
    Button,
    Radio,
    MenuItem,
    RadioGroup,
} from "@material-ui/core";
import styled from 'styled-components';

import {CameraIcon, Container, Page, ChangeRoleBlock, ErrorDescription, HiddenInput} from "./SignUp2_Talent.styles";

import { HygienistSkill, roles } from "utils/constants";
import {getTypeByRoleNumber, uploadPhoto, getRoleByTypeNumber} from "utils";
import MaterialInput from "../../../components/Inputs/MaterialInput";
import {MaterialSelector} from "../../../components/Selector";
import {UserAccountProps, HYGIENIST_TYPES, HygienistProps, SkillsProps} from "utils/types";
import Api from "../../../api";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import GreenCheckmarkWithText from "../../../components/GreenCheckmarkWithText";
import { normalizeSignupText } from '../../../utils/signupText';
import clsx from "clsx";
import WorkExperience from "./components/WorkExperience";
import {AboutYou} from "./components/AboutYou";
import {SimpleModal} from "components/Modal";
import LeftHandedModal from "./components/LeftHandedModal";
import AssistantSkillsCheckModal from "./components/AssistantSkillsCheckModal";
import AboutMeCompletedModal from "./components/AboutMeCompletedModal";
import QualificationModal from "./components/QualificationModal";
import {usePersistedState, usePersistedApi} from "../../../hooks";
import entities from "../../../reduxStore/entityKeys";
import {useActionApi} from "../../../hooks";
import FixedLoader from 'components/FixedLoader/FixedLoader';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Language } from "api/Api";
import { trackSignUpComplete, UserType, trackLead } from '../../../utils/facebookPixel';
import { 
    trackSignUpComplete as gtmTrackSignUpComplete,
    UserType as GTMUserType
} from '../../../utils/gtmDataLayer';
import {
    CREDENTIAL_MONTH_OPTIONS,
    GRADUATION_YEAR_HINT,
    LICENSED_SINCE_HINT,
    MIN_CREDENTIAL_OPTION_YEAR,
    getLicensedSinceFieldLabel,
    isFirstLicensedNotApplicablePath,
    validateEducationCredentials,
} from '../../../utils/educationCredentials';
import { openExternalUrl } from '../../../utils/nativeApp';


declare let cordova: any

// @ts-ignore
const TempStars = window.TempStars;
// @ts-ignore
const app = window.app;
// @ts-ignore
const Template7 = window.Template7

const supportLink= 'https://support.tempstars.com/hc/en-us/requests/new?'
const supportHosts = ['support.tempstars.com'] as const;

const LEFT_HANDED_OPTIONS = {
    NOT_LEFT_HANDED: 0,
    LEFT_HANDED: 1,
}

// Country-specific language constants will be used instead

interface ErrorProps {
    license: string,
    education: string,
    graduationYear: string,
    firstLicensedYear?: string,
    firstLicensedMonth?: string,
    about: string,
    photo?: string,
    qualification?: string,
    creationError?: string,
    licensed?: boolean,
    isLeftHanded?: boolean,
    languages?: string,
}

interface LocationState {
    updatedHygienist?: HygienistProps;
    email?: string;

}

const hygienistMenuInit = (user: any) => {
    const contentForMenu = {
        fullname: _.capitalize( user.hygienist.firstName ) + ' ' + _.capitalize( user.hygienist.lastName ),
        city: _.trim( user.hygienist.city ),
        province: user.hygienist.province,
        photoUrl: (user.hygienist.photoUrl) ? user.hygienist.photoUrl : 'img/hygienist.png',
        type: user.hygienist.type,
    };

    const template = document.getElementById("hygienist-menu")?.innerHTML;
    const compiledTemplate = Template7.compile(template);
    const panel = document.getElementById("panel-menu");
    panel && (panel.innerHTML = compiledTemplate(contentForMenu));
}

const JobSeekingStatusContainer = styled.div`
  padding: 16px;
  background-color: #f7f9ff;
  border: 1px solid #e0e7ff;
  border-radius: 8px;
  margin: 15px 0;
`;

const JobSeekingStatusTitle = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: #0B4598;
  margin-bottom: 10px;
`;

/**
 * Stacks its label, control row and hint. Deliberately NOT `.inputBox`: that class is
 * `display: flex; flex-direction: row` under `.contentBlock`, which would lay the three
 * blocks out side by side instead of as one question.
 */
const CredentialGroup = styled.div`
  display: block;
`;

const FieldGroupTitle = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: #0B4598;
  margin-bottom: 10px;
`;

const FieldGroupHint = styled.p`
  font-size: 0.875rem;
  color: #6d6d72;
  line-height: 1.4;
  margin: 6px 0 0;
`;

const JobSeekingStatusDescription = styled.div`
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 15px;
  line-height: 1.4;
`;

const RadioOptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f0f4ff;
  }
  
  &.selected {
    background-color: #e7f3fe;
    border-color: #b3d7f9;
  }
`;

const RadioLabelContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const RadioMainLabel = styled.div`
  font-size: 1rem;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
`;

const RadioDescription = styled.div`
  font-size: 0.875rem;
  color: #666;
  line-height: 1.3;
  font-weight: normal;
`;

export default function SignUp2_Talent() {
    const history = useHistory();

    const location = useLocation<LocationState>();
    const { updatedHygienist } = location.state || {};
  
    const [hygienist, setHygienist] = useState(
        updatedHygienist ? updatedHygienist as HygienistProps : {} as HygienistProps
    );

    let duplicate = false;

    const [
      userAccount,
      hygienistUserLoading,
      hygienistUserError,
      getHygienistUser
    ] = usePersistedApi({
      apiMethod: Api.getUser,
      entityName: entities.user,
      initialValue: {} as UserAccountProps
    });
  
    useEffect(() => {
      if (!updatedHygienist && !hygienistUserLoading) {
        getHygienistUser({});
      }
    }, []);

    useEffect(() => {
      if (!updatedHygienist && userAccount?.hygienist) {
        setHygienist(userAccount.hygienist);
      }
    }, [userAccount?.hygienist]);

    const province = hygienist?.province
    const country = hygienist?.country
    const hygienistId = hygienist?.id

    const roleNumber = getRoleByTypeNumber(hygienist?.type);
    const signup = useSignupPage('talent_profile', 'talent', hygienist?.type == null ? undefined : roleNumber);
    const isHygienistOrAssistant = roleNumber === roles.HYGIENIST || roleNumber === roles.ASSISTANT

    let userRole: string | undefined;
    let license: string | undefined = undefined;
    let userRoleAnalytics: string | undefined = undefined;

    switch (roleNumber) {
        case roles.HYGIENIST:
            userRole = 'Dental Hygienist';
            userRoleAnalytics = 'Hygienist'
            license = 'Hygiene License #'
            break;
        case roles.ASSISTANT:
            userRole = 'Dental Assistant';
            userRoleAnalytics = 'Assistant'
            license = 'Assistant Certificate #'
            break;
        case roles.FRONT_DESK:
            userRole = 'Dental Admin / Manager';
            userRoleAnalytics = 'Admin'
            break;
        case roles.ASSOCIATE_DENTIST:
            userRole = 'Associate Dentist';
            userRoleAnalytics = 'Associate'
            license = 'Dental License #'
            break;
        default:
            roleNumber satisfies never;
    }

    const [screenError, setScreenError] = useState<string | undefined>();
    const inputPhotoRef = useRef<HTMLInputElement>(null)
    const htmlElRef = useRef<HTMLInputElement>(null)
    const submitRef = useRef<HTMLInputElement>(null)
    const [imageSrc, setImageSrc] = useState<string | undefined>()
    const [isOpenQualificationModal, setOpenQualificationModal] = useState(false);
    const [isOpenAboutModal, setOpenAboutModal] = useState(false);
    const [isOpenPositionModal, setOpenPositionModal] = useState(false);
    const [isQualificationFilled, setQualificationFilled] = useState<boolean | undefined>();
    const [isWorkExperienceFilled, setWorkExperienceFilled] = useState<boolean | undefined>();
    const [isAboutFilled, setAboutFilled] = useState<boolean | undefined>();
    const [userQualification, setUserQualification] = useState<string | undefined>();
    const [userQualificationTitle, setUserQualificationTitle] = useState<string | undefined>();
    const [skills, setSkills] = useState<HygienistSkill[]>([]);
    const [checkedSkills, setCheckedSkills] = useState<HygienistSkill[]>([]);
    const [licensed, setLicensed] = useState<boolean | undefined>(isHygienistOrAssistant ? undefined : true);
    const [isLeftHanded, setIsLeftHanded] = useState<boolean>(false);
    const [isLeftHandedModal, setIsLeftHandedModal] = useState(false);
    const [isAssistantSkillsCheckModal, setAssistantSkillsCheckModal] = useState(false);
    const [isAboutMeCompletedModal, setAboutMeCompletedModal] = useState(false);
    const [skipAboutMe, setSkipAboutMe] = useState(false);
    const [formData, setFormData] = useState({});
    const [about, setAbout] = useState<string>('');
    const [disabledSkills, setDisabledSkills] = useState<boolean>(isHygienistOrAssistant);
    const [school, setSchool] = useState<string>('');
    const [licenseNumber, setLicenseNumber] = useState<string>('');
    const analyticsTracked = useRef(false);
    const [jobSeekingStatus, setJobSeekingStatus] = useState<number | null>(null);
    const selectedLanguagesRef = useRef<number[]>([]);
    const qualificationValidationIdRef = useRef(0);
    const qualificationSnapshotRef = useRef('');
    qualificationSnapshotRef.current = JSON.stringify([
        isOpenQualificationModal, roleNumber, province, licensed, userQualification,
        licenseNumber, school, isLeftHanded, checkedSkills.map(skill => skill.id),
    ]);

    const setUser = usePersistedState({
        entityName: entities.user,
    })[1];

    useEffect(() => {
        if (isHygienistOrAssistant && roleNumber && province) {
            getSkills();
        }
    },[roleNumber, province])

    useEffect(() => {
        if (typeof isAboutFilled === 'boolean' || !!about.length) {
            setAboutFilled(!!about.length)
        }
    },[about])

    useEffect(() => {
        if (country !== undefined && province !== undefined && !analyticsTracked.current) {
            TempStars.Analytics.track('view_talent_createAccount', {
                country: country === 0 ? 'CA' : 'US',
                province: province || '',
                userRole: userRoleAnalytics || ''
            });
            analyticsTracked.current = true;
        }
    }, [country, province, userRoleAnalytics]);

    useEffect(() => {
        if (roleNumber === roles.HYGIENIST && licensed) {
            setUserQualificationTitle('RDH')
        }
        if (roleNumber === roles.HYGIENIST && !licensed) {
            setUserQualificationTitle(undefined)
        }
        if (roleNumber === roles.ASSISTANT && licensed) {
            setUserQualificationTitle(userQualification || 'CDA')
        }
        if (roleNumber === roles.ASSISTANT && (licensed === false)) {
            setUserQualificationTitle('DA')
        }
    },[roleNumber, licensed, userQualification])

    useEffect(() => {
        if (isOpenQualificationModal) {
            document.querySelector( '#bodySignUp' )?.scrollIntoView( { block: 'start' } )
        }
    },[isOpenQualificationModal])

    const getSkills = async () => {
        const skills = await Api.getSkills({type: getTypeByRoleNumber(roleNumber), state: province});
        setSkills(skills);
    }

    const [errorMessage, setErrorMessage] = useState<ErrorProps>({
        license: '',
        education: '',
        graduationYear: '',
        firstLicensedYear: '',
        firstLicensedMonth: '',
        about: '',
        languages: '',
    });

    const contactSupport = () => {
        openExternalUrl(supportLink, supportHosts);
    }

    const completeSignUpWithErrors = (userAccount: any) => {
        history.push('loading');
        TempStars.Api.addToMailchimp(hygienist?.id || userAccount.hygienistId, userAccount.email)
        TempStars.Menu.logoutWoModal()
    }

    const sendAnalytic = (userAccount: any) => {
        const countryStr = country ? 'US' : 'CA';
        const props = {
            userType: "Dental Worker",
            userRole: userRoleAnalytics,
            userStatus: 0,
            country: countryStr,
            province: province,
            $email: userAccount.email,
        }
        TempStars.Analytics.setProfileProperties({
            ...props,
        });
        TempStars.Analytics.register({
            ...props,
            appType: window.cordova ? 'Mobile' : 'Web',
        })
    }

    const onSubmit = async (event: any) => {
        event.preventDefault()
        submitRef?.current?.click()
        const {graduationYear, photoUrl, qualification, education, firstLicensedYear, firstLicensedMonth} = event.target
        let errors = {}
        let baseForm = {}

        if (!graduationYear?.value.length) {
            errors = {...errors, graduationYear: 'Please select your graduation year'};
        }

        const firstLicensedNa = isFirstLicensedNotApplicablePath(hygienist?.type, licensed);
        if (!firstLicensedNa) {
            const validated = validateEducationCredentials({
                graduationYear: graduationYear?.value,
                firstLicensedYear: firstLicensedYear?.value,
                firstLicensedMonth: firstLicensedMonth?.value,
                firstLicensedNotApplicable: false,
            });
            if (!validated.ok) {
                errors = {
                    ...errors,
                    ...(validated.field ? { [validated.field]: validated.message } : { firstLicensedYear: validated.message }),
                };
            }
        }

        if(!isHygienistOrAssistant && !normalizeSignupText(education?.value)) {
            errors = {...errors, education: 'Please enter your School or Institute'};
        }

        if(!isQualificationFilled) {
            setQualificationFilled(false);
        }

        if(!isWorkExperienceFilled) {
            setWorkExperienceFilled(false);
        }

        if(Object.values(errors).find((err: any) => !!err.length)) {
            setErrorMessage(errors as ErrorProps);
            signup.error('validation_failed');
            TempStars.Analytics.track('sign-up - Failed to Save Profile', {failedFields: Object.keys(errors)});
            return;
        }

        if((!isQualificationFilled && isHygienistOrAssistant) || !graduationYear?.value.length || (!isHygienistOrAssistant && !normalizeSignupText(education?.value)) || (!firstLicensedNa && (!firstLicensedYear?.value?.length || !firstLicensedMonth?.value?.length))) {
            signup.error('validation_failed');
            return;
        }

        const validatedForSave = firstLicensedNa
            ? validateEducationCredentials({
                graduationYear: graduationYear.value,
                firstLicensedNotApplicable: true,
            })
            : validateEducationCredentials({
                graduationYear: graduationYear.value,
                firstLicensedYear: firstLicensedYear.value,
                firstLicensedMonth: firstLicensedMonth.value,
                firstLicensedNotApplicable: false,
            });

        if (!validatedForSave.ok) {
            const field = validatedForSave.field ?? 'firstLicensedYear';
            setErrorMessage({ ...errors, [field]: validatedForSave.message } as ErrorProps);
            return;
        }

        app.showPreloader('Setting Up Profile');

        baseForm = {
            ...baseForm,
            hygienistId: hygienistId,
            graduationYear: validatedForSave.graduationYear,
            firstLicensedYear: validatedForSave.firstLicensedYear,
            firstLicensedMonth: validatedForSave.firstLicensedMonth,
            firstLicensedNotApplicable: validatedForSave.firstLicensedNotApplicable,
            isComplete: 1,
            starScore: 4,
        };

        if(!isHygienistOrAssistant) {
            baseForm = {
                ...baseForm,
                school: normalizeSignupText(education?.value),
            }
        }

        if(about?.length) {
            baseForm = {
                ...baseForm,
                about: about,
            };
        }

        if (checkedSkills.find(skill => skill.name === 'RH')) {
            baseForm = {
                ...baseForm,
                isRestorative: 1,
            }
        }
        if (checkedSkills.find(skill => skill.name === 'OH')) {
            baseForm = {
                ...baseForm,
                isOrtho: 1,
            }
        }

        if (imageSrc) {
            const photoFileName = await uploadPhoto(imageSrc, photoUrl, userAccount.id, errorMessage, setErrorMessage);
            if (photoFileName) {
                baseForm = {
                    ...baseForm,
                    photoUrl: photoFileName,
                };
            }
        }

        if(isLeftHanded) {
            baseForm = {
                ...baseForm,
                isLeftHanded: LEFT_HANDED_OPTIONS.LEFT_HANDED,
            }
        }

        if (isHygienistOrAssistant && jobSeekingStatus !== null) {
            try {
                baseForm = {
                    ...baseForm,
                    showForHire: jobSeekingStatus,
                };
            } catch (error) {
                // Continue with signup even if this fails
            }
        }
        
        let profileSaved = false;
        try {
            if (isHygienistOrAssistant) {
                const licenseQualificationSkillSubmit = skills.find((skill) => skill.license && skill.qualification)
                const checkedSkillIds = checkedSkills.map((skill: HygienistSkill) => skill.id)
                let resultSkills = qualification?.value
                    ? [...checkedSkillIds, Number(qualification.value)]
                    : checkedSkillIds
                if (
                    licensed === false &&
                    licenseQualificationSkillSubmit &&
                    !resultSkills.includes(licenseQualificationSkillSubmit.id)
                ) {
                    resultSkills = [...resultSkills, licenseQualificationSkillSubmit.id]
                }
                if (resultSkills.length === 0) {
                    const fallbackSkill = skills.find((skill) => skill.license);
                    if (fallbackSkill) {
                        resultSkills = [fallbackSkill.id];
                    }
                }
                const arraySkillIds = Array.from(new Set(resultSkills))
                await Api.replaceHygienistSkills(arraySkillIds);

                try {
                    // Read-only hold probe — detection itself runs server-side
                    // when the profile is created. Assigns the OUTER
                    // `duplicate` (a shadowing `let` here previously made the
                    // duplicate routing below unreachable).
                    const userAccount = TempStars.User.getCurrentUser();
                    const checkForDuplicateHygienist = await Api.checkForDuplicateHygienist(hygienistId, hygienist?.firstName, hygienist?.lastName, userAccount.id, hygienist?.type, hygienist?.province)
                    duplicate = checkForDuplicateHygienist.isDuplicate;
                } catch (duplicateError) {
                    // Never block signup on the duplicate probe.
                    duplicate = false;
                }
            }

            await Api.updateHygienistSignup({...formData, ...baseForm});
            profileSaved = true;
            signup.submitted({ role: roleNumber });
            await TempStars.User.updateRegistration()
            await TempStars.User.reLogIn();
            const userAccount = TempStars.User.getCurrentUser();
            await Api.updateToken()
            setUser(userAccount)
            sendAnalytic(userAccount)

            // Persist selected languages using dedicated endpoint
            if (selectedLanguagesRef.current.length) {
                try {
                    await Api.addLanguages(selectedLanguagesRef.current);
                } catch (err) {
                    console.error('Failed to save languages', err);
                }
            }

            app.hidePreloader();
            if (roleNumber === roles.ASSOCIATE_DENTIST || roleNumber === roles.FRONT_DESK) {
                hygienistMenuInit(userAccount)
                const {hygienist} = userAccount;
                const props = {
                    userType: "Dental Worker",
                    userStatus: 'Active',
                    country: hygienist.countryStr,
                    province: hygienist.province,
                    $email: hygienist.email,
                    userRole: userRoleAnalytics,
                }
                TempStars.Analytics.setProfileProperties({
                    ...props,
                    graduationYear: hygienist.graduationYear + '-01-01',
                });
                TempStars.Analytics.register({
                    ...props,
                    appType: window.cordova ? 'Mobile' : 'Web',
                })
                TempStars.Analytics.track('sign-up - complete profile');
                
                // Track Talent sign-up completion (conversion event)
                // Facebook Pixel (existing - with Advanced Matching)
                await trackSignUpComplete({
                    userType: UserType.DENTAL_PROFESSIONAL,
                    userData: {
                        email: userAccount.email,
                        phone: hygienist.phone,
                        firstName: hygienist.firstName,
                        lastName: hygienist.lastName,
                        country: hygienist.country, // Pass numeric country (0=CA, 1=US)
                        province: hygienist.province,
                        city: hygienist.city,
                    }
                });
                
                // GTM dataLayer (new - NO PII, only IDs)
                gtmTrackSignUpComplete({
                    userId: userAccount.id,
                    userType: GTMUserType.DENTAL_PROFESSIONAL,
                    userRole: hygienist.roleId === roles.HYGIENIST ? 'hygienist' : 'assistant',
                    country: hygienist.country === 0 ? 'CA' : 'US',
                    province: hygienist.province,
                    city: hygienist.city,
                    hygienistId: hygienist.id,
                });
                
                history.push({
                    pathname: 'jobPostsList'
                })
            } else {
                TempStars.Analytics.track('sign-up - complete profile');
                
                // Track Talent sign-up completion (conversion event)
                // Facebook Pixel (existing - with Advanced Matching)
                await trackSignUpComplete({
                    userType: UserType.DENTAL_PROFESSIONAL,
                    userData: {
                        email: userAccount.email,
                        phone: hygienist?.phone,
                        firstName: hygienist?.firstName,
                        lastName: hygienist?.lastName,
                        country: country, // Pass numeric country (0=CA, 1=US)
                        province: hygienist?.province,
                        city: hygienist?.city,
                    }
                });
                
                // GTM dataLayer (new - NO PII, only IDs)
                gtmTrackSignUpComplete({
                    userId: userAccount.id,
                    userType: GTMUserType.DENTAL_PROFESSIONAL,
                    userRole: roleNumber === roles.HYGIENIST ? 'hygienist' : 'assistant',
                    country: country === 0 ? 'CA' : 'US',
                    province: hygienist?.province,
                    city: hygienist?.city,
                    hygienistId: hygienist?.id,
                });
                
                history.push('loading');
                if (!duplicate && (roleNumber===roles.HYGIENIST || roleNumber===roles.ASSISTANT)) {
                    return history.push({pathname: 'Onboarding_Talent'}, {firstName: hygienist?.firstName})
                } else {
                    if(duplicate) {
                        signup.duplicate();
                        TempStars.Analytics.track('Select-Route', {
                            route_selected: 'route_duplicate'
                        });
                    }
                    return TempStars.App.gotoStartingPage()
                }
            }
        } catch (e: any) {
            // Refresh/login/conversion failures after a committed save are not page-save failures.
            if (!profileSaved) {
                signup.error(signupErrorReason(e));
                if (signupErrorReason(e) === 'duplicate_account') signup.duplicate();
            }
            const userAccount = TempStars.User.getCurrentUser();
            app.hidePreloader();
            TempStars.Analytics.track('sign-up - error', { errorReason: e?.error?.message });

            if (e?.error?.message === 'Duplicate phone') {
                setScreenError('This phone is already in use.')
                return;
            } 
            
            if (e?.error?.message === 'Duplicate') {
                app.modal({
                    title: 'Possible Account Duplicate?',
                    text: `
                    It looks like this might be a duplicate membership account.<br><br>

                    If you already have an account, you can go back to the sign in screen and use "Forgot Password" to login to your account. <br><br> 

                    If you're sure you don't already have an account, contact Member Support, and we'll help get you going. 
                    `,
                    buttons: [
                        { 
                            text: 'Sign In', 
                            onClick: () => {
                                completeSignUpWithErrors(userAccount);
                            }
                        },
                        { 
                            text: 'Contact Support', 
                            onClick: () => {
                                contactSupport();
                                completeSignUpWithErrors(userAccount);
                            }
                        }
                    ]
                });
            } else {
                app.modal({
                    title: 'Account creation Error',
                    text: `Please, contact support with your account userId: ${userAccount.id}`,
                    buttons: [
                        { 
                            text: 'Contact Support', 
                            onClick: () => {
                                contactSupport();
                                completeSignUpWithErrors(userAccount);
                            }
                        },
                        { 
                            text: 'OK', 
                            onClick: () => {}
                        },
                    ]
                });
            }
            return;
        }
    };

    const openQualificationModal = (e: any) => {
        e.preventDefault();
        setOpenQualificationModal(!isOpenQualificationModal);
    }

    const openPositionModal = (e: any) => {
        e.preventDefault();
        setOpenPositionModal(!isOpenPositionModal);
    }

    const openAboutModal = (e: any) => {
        e.preventDefault();
        setOpenAboutModal(!isOpenAboutModal);
    }

    const webPhotoHandler = (photoUrl: any) => {
        const f = photoUrl.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            event && setImageSrc(event?.target?.result as string)
        };
        reader.readAsDataURL(f);
    }

    // Derived skill categories for validation in onSubmitSkills
    const licenseSkill = skills.find(skill => skill.license && !skill.qualification)
    const licenseQualificationSkill = skills.find(skill => skill.license && skill.qualification)
    const qualificationSkills = skills.filter((skill: HygienistSkill) => skill.qualification && !skill.license)

    const onSubmitSkills = async (event: any) => {
        event.preventDefault()
        const validationId = ++qualificationValidationIdRef.current;
        const submittedSnapshot = qualificationSnapshotRef.current;
        const submittedForm = event.currentTarget as HTMLFormElement;
        const readFormValues = () => JSON.stringify(Array.from(new FormData(submittedForm).entries()));
        const submittedValues = readFormValues();
        let errors = {}
        let skillsQualificationsForm = {}
        setErrorMessage(errors as ErrorProps);
        const {license, education, qualification} = event.target
        const licenseValue = license?.value?.trim() || '';
        const additionalChecked = skills.filter((skill: HygienistSkill) => event.target[skill.name]?.checked)
        let checkedSkills: HygienistSkill[]
        if (licensed) {
            const baseSkills: HygienistSkill[] = licenseSkill ? [licenseSkill] : [];
            checkedSkills = [
                ...baseSkills,
                ...additionalChecked.filter((s) => !baseSkills.some(b => b.id === s.id)),
            ]
        } else if (licenseQualificationSkill) {
            checkedSkills = [
                licenseQualificationSkill,
                ...additionalChecked.filter((s) => s.id !== licenseQualificationSkill.id),
            ]
        } else {
            checkedSkills = additionalChecked
        }
        if(licensed || !licenseQualificationSkill) {
            if (!licensed && roles.HYGIENIST === roleNumber) {
                errors = {...errors, licensed: 'Please confirm your qualification'};
            }
            if (roles.HYGIENIST === roleNumber && !licenseValue) {
                errors = {...errors, license: `Please enter your License #`};
            }
            if (roles.ASSISTANT === roleNumber && userQualification === 'CDA2' && province === 'ON' && !licenseValue) {
                errors = {...errors, license: `Please enter your Certificate #`};
            }

            if (licensed && roles.HYGIENIST === roleNumber && licenseValue) {
                try {
                    const checkCDHONumber = await Api.checkUniqueHygienistCDHONumber({ CDHONumber: licenseValue, type: getTypeByRoleNumber(roleNumber), province: province })
                    if (checkCDHONumber.isDuplicate) {
                        errors = {...errors, license: 'Oops! This license number seems to already be in use.'};
                    }
                } catch (e: any) {
                    const isDuplicate = e?.status === 409 && e?.body?.error?.isDuplicate === 1;
                    errors = {...errors, license: isDuplicate
                        ? 'Oops! This license number seems to already be in use.'
                        : 'We could not verify your license number. Please try again.'};
                }
                // A newer Save, edit or closed modal supersedes this lookup result.
                if (validationId !== qualificationValidationIdRef.current
                    || submittedSnapshot !== qualificationSnapshotRef.current
                    || !submittedForm.isConnected
                    || submittedValues !== readFormValues()) {
                    return;
                }
            }
            if(licensed && roles.ASSISTANT === roleNumber && !userQualification) {
                errors = {...errors, qualification: 'Please select a qualification level'};
            }
            if (!normalizeSignupText(education?.value)) {
                errors = {...errors, education: 'Please enter your School or Institute'};
            }
        }
        /** T2-5789: unlicensed DA must still pick a qualification (was skipped when licenseQualificationSkill exists) */
        if (roles.ASSISTANT === roleNumber && licensed === false && !userQualification) {
            errors = { ...errors, qualification: 'Please select a qualification level' };
        }
        if (roles.ASSISTANT === roleNumber && licensed === false && !normalizeSignupText(education?.value)) {
            errors = { ...errors, education: 'Please enter your School or Institute' };
        }
        if(isHygienistOrAssistant && licensed === undefined) {
            errors = {...errors, licensed: 'Please confirm your qualification'};
        }
        setCheckedSkills(checkedSkills);

        const isNoLanguageSelected = selectedLanguagesRef.current.length === 0;
        console.log('isNoLanguageSelected', isNoLanguageSelected);
        console.log('selectedLanguagesRef.current', selectedLanguagesRef.current);
        console.log('isHygienistOrAssistant', isHygienistOrAssistant);
        if (isHygienistOrAssistant && isNoLanguageSelected) {
            errors = {...errors, languages: 'Please select at least one language'};
        }

        if(Object.values(errors).find((err: any) => !!err.length)) {
            setErrorMessage(errors as ErrorProps);
            setQualificationFilled(false);
            document.querySelector( '#bodySignUp' )?.scrollIntoView( { behavior: 'smooth', block: 'start' } );
            TempStars.Analytics.track('sign-up - Failed to Save Qualifications and Skills', {failedFields: Object.keys(errors)});
            return;
        }
        setQualificationFilled(true);
        if (licenseValue) {
            skillsQualificationsForm = {
                ...skillsQualificationsForm,
                CDHONumber: licenseValue,
            };
        }
        if (qualification?.value) {
            const qualificationSkill = JSON.parse(qualification.value);
            checkedSkills = [...checkedSkills, qualificationSkill];
            setCheckedSkills(checkedSkills);
            let level = qualificationSkill.id === 3 ? 2 : 1;
            skillsQualificationsForm ={
                ...skillsQualificationsForm,
                level: level,
            };
        }
        skillsQualificationsForm = {
            ...skillsQualificationsForm,
            school: normalizeSignupText(education?.value),
        };

        if (roleNumber === roles.ASSISTANT && !checkedSkills.some(skill => ['TDX', 'PSIC', 'CPRC'].includes(skill.name))) {
            setAssistantSkillsCheckModal(!isAssistantSkillsCheckModal)
        } else {
            TempStars.Analytics.track('sign-up - Saved Qualifications and Skills');
            setAssistantSkillsCheckModal(false);
            setOpenQualificationModal(false)
        }
        setFormData(skillsQualificationsForm);
    }

    const graduateYears = [];
    for (let i = new Date().getFullYear(); i >= MIN_CREDENTIAL_OPTION_YEAR; i--) {
        graduateYears.push(i);
    }

    const schoolHandler = (e: any) => {
        if(e.target.value) {
            setErrorMessage({ ...errorMessage, education: '' });
        }
    }

    const [changeRoleLoading, , changeRole] = useActionApi({
        apiMethod: Api.changeRole,
        onSuccess: () => { signup.switched('office'); history.push({pathname: 'SignUp1_DO'}); },
        onError: (error) => signup.error(signupErrorReason(error)),
    });

    const changeRoleToDentist = async () => {
        TempStars.Analytics.track('Select-Route', {
            route_selected: 'UserToDentalOffice'
        });
        try {
            await Api.deleteHygienist(Number(hygienistId));
            await changeRole(roles.DENTIST);
        } catch (error) {
            signup.error(signupErrorReason(error));
            setScreenError('Unable to change account type. Please try again.');
        }
    }

    const handleSignOut = () => {
        // Clear React state and local storage
        ls.remove('userAuth');
        ls.remove('userAccount');
        safeLocalStorage.removeItem('userAuth');
        safeLocalStorage.removeItem('userAccount');
        
        // After signing out, send returning users to Login rather than the
        // role-picker. They can still start a new signup from Login's
        // "Sign Up" link if needed.
        history.push({
            pathname: 'Login'
        });
    }

    const handleAssistantSkillsCheckModalClose = () => {
        setAssistantSkillsCheckModal(!isAssistantSkillsCheckModal);
        setOpenQualificationModal(false);
    }

    const handleAboutMeCompletedModalClose = () => {
        setAboutMeCompletedModal(false);
        setSkipAboutMe(true);
    };

    const handleCompleteAboutMe = () => {
        setAboutMeCompletedModal(false);
        setOpenAboutModal(true);
    };

    // JSS feature: Set default job seeking status for hygienists and assistants
    useEffect(() => {
        if (isHygienistOrAssistant && jobSeekingStatus === null) {
            setJobSeekingStatus(0);
        }
    }, [isHygienistOrAssistant, jobSeekingStatus]);

    // Languages feature: Fetch all languages and region-specific lists from the backend
    const [languagesList, setLanguagesList] = useState<Language[]>([]);
    const [regionalLanguages, setRegionalLanguages] = useState<{
        common: Language[];
        additional: Language[];
    }>({ common: [], additional: [] });
    const [englishId, setEnglishId] = useState<number | null>(null);

    useEffect(() => {
        (async () => {
            try {
                const [langs, regional] = await Promise.all([
                    Api.getLanguages(),
                    Api.getRegionalLanguages(),
                ]);

                setLanguagesList(langs);
                setRegionalLanguages({
                    common: regional.common,
                    additional: regional.additional,
                });

                // Pre-select English for convenience if present
                const english = langs.find(l => l.name.toLowerCase() === 'english');
                if (english) {
                    setEnglishId(english.id);
                }
            } catch (e) {
                console.error('Failed to fetch regional languages', e);
            }
        })();
    }, []);

    return (
        <Page>
            <Container>
                <SimpleModal isOpen={isAboutMeCompletedModal}>
                    <AboutMeCompletedModal
                        onClose={handleAboutMeCompletedModalClose}
                        onCompleteAboutMe={handleCompleteAboutMe}
                    />
                </SimpleModal>
                <div className={"bodySignUp contentBlock"} id={"bodySignUp"}>
                {isHygienistOrAssistant && (
                    <QualificationModal
                        isOpen={isOpenQualificationModal}
                        onClose={() => setOpenQualificationModal(false)}
                        onSubmit={onSubmitSkills}
                        roleNumber={roleNumber}
                        province={province}
                        skills={skills}
                        licensed={licensed}
                        setLicensed={setLicensed}
                        disabledSkills={disabledSkills}
                        setDisabledSkills={setDisabledSkills}
                        checkedSkills={checkedSkills}
                        setCheckedSkills={setCheckedSkills}
                        isLeftHanded={isLeftHanded}
                        setIsLeftHanded={setIsLeftHanded}
                        userQualification={userQualification}
                        setUserQualification={setUserQualification}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                            commonLanguages={regionalLanguages.common}
                            otherLanguages={regionalLanguages.additional}
                        initialSelectedLanguages={englishId && languagesList.length ? languagesList.filter(l => l.id === englishId) : []}
                        selectedLanguagesRef={selectedLanguagesRef}
                        isLeftHandedModal={isLeftHandedModal}
                        setIsLeftHandedModal={setIsLeftHandedModal}
                        isAssistantSkillsCheckModal={isAssistantSkillsCheckModal}
                        setAssistantSkillsCheckModal={setAssistantSkillsCheckModal}
                        handleAssistantSkillsCheckModalClose={handleAssistantSkillsCheckModalClose}
                        school={school}
                        setSchool={setSchool}
                        licenseNumber={licenseNumber}
                        setLicenseNumber={setLicenseNumber}
                    />
                )}

                    <AboutYou
                        about={about}
                        name={hygienist?.firstName}
                        isOpen={isOpenAboutModal}
                        onSaveAbout={setAbout}
                        onClose={() => setOpenAboutModal(false)}
                    />

                    <WorkExperience
                        country={country || 0}
                        isOpen={isOpenPositionModal}
                        onSaveExperience={() => setWorkExperienceFilled(true)}
                        onClose={() => setOpenPositionModal(false)}
                        isHygienistOrAssistant={isHygienistOrAssistant}
                    />

                    <div>
                        <HeaderStatusBar buttonClassName={'logout-link'} buttonText={'Sign Out'} withArrow onButton={handleSignOut} />
                        <form
                            id="signup-form"
                            data-testid="signup-talent-profile-form"
                            className="content-block contentBlock"
                            onSubmit={onSubmit}
                        >
                            <ChangeRoleBlock><a onClick={changeRoleToDentist}>Are you a Dental Office? Register here</a></ChangeRoleBlock>
                            <div className="list-block inset inputBox photoBox">
                                <HiddenInput
                                    type='file'
                                    name={'photoUrl'}
                                    ref={inputPhotoRef}
                                    onChange={(e: any) => webPhotoHandler(e.target)}
                                    accept="image/gif,image/jpeg,image/png,image/jpg,image/*"
                                    title="Upload profile photo"
                                    aria-label="Upload profile photo"
                                />

                                <div
                                    className={'profile-photo-parent no-fastclick'}
                                    onClick={() => {
                                        imageSrc
                                            ? setImageSrc(undefined)
                                            : inputPhotoRef.current?.click()
                                    }}
                                >
                                    {imageSrc
                                        ? <img className={'photoImg'} src={imageSrc} alt="profilePhoto"/>
                                        : <CameraIcon/>
                                    }
                                </div>

                                <div className="nameBox">
                                    {hygienist?.firstName} {hygienist?.lastName}{userQualificationTitle && `, ${userQualificationTitle}`}
                                </div>
                            </div>

                            <CredentialGroup
                              className="list-block inset"
                              id="signup-graduation-year"
                              data-testid="signup-graduation-year"
                              content-desc="signup-graduation-year"
                            >
                                <MaterialSelector
                                    id={'graduationYear'}
                                    name={'graduationYear'}
                                    label={'Graduation Year'}
                                    errorMessage={errorMessage?.graduationYear}
                                    onChange={() => setErrorMessage({...errorMessage, graduationYear: ''})}
                                >
                                    {graduateYears.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                                </MaterialSelector>
                                <FieldGroupHint>{GRADUATION_YEAR_HINT}</FieldGroupHint>
                            </CredentialGroup>
                            {!isFirstLicensedNotApplicablePath(hygienist?.type, licensed) ? (
                                <CredentialGroup
                                  className="list-block inset"
                                  id="signup-first-licensed"
                                  data-testid="signup-first-licensed"
                                  content-desc="signup-first-licensed"
                                >
                                    <FieldGroupTitle>{getLicensedSinceFieldLabel(hygienist?.type, hygienist?.country)}</FieldGroupTitle>
                                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                                        <div
                                          style={{ flex: '1 1 0', minWidth: 0 }}
                                          id="signup-first-licensed-month"
                                          data-testid="signup-first-licensed-month"
                                          content-desc="signup-first-licensed-month"
                                        >
                                            <MaterialSelector
                                                id={'firstLicensedMonth'}
                                                name={'firstLicensedMonth'}
                                                label={'Month'}
                                                errorMessage={errorMessage?.firstLicensedMonth}
                                                onChange={() => setErrorMessage({...errorMessage, firstLicensedMonth: ''})}
                                            >
                                                {CREDENTIAL_MONTH_OPTIONS.map((m) => (
                                                  <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                                                ))}
                                            </MaterialSelector>
                                        </div>
                                        <div
                                          style={{ flex: '0 0 38%', minWidth: 0 }}
                                          id="signup-first-licensed-year"
                                          data-testid="signup-first-licensed-year"
                                          content-desc="signup-first-licensed-year"
                                        >
                                            <MaterialSelector
                                                id={'firstLicensedYear'}
                                                name={'firstLicensedYear'}
                                                label={'Year'}
                                                errorMessage={errorMessage?.firstLicensedYear}
                                                onChange={() => setErrorMessage({...errorMessage, firstLicensedYear: ''})}
                                            >
                                                {graduateYears.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                                            </MaterialSelector>
                                        </div>
                                    </div>
                                    <FieldGroupHint>{LICENSED_SINCE_HINT}</FieldGroupHint>
                                </CredentialGroup>
                            ) : (
                                <FieldGroupHint
                                    id="signup-first-licensed-na"
                                    data-testid="signup-first-licensed-na"
                                    style={{ margin: '0 0 12px' }}
                                >
                                    First Licensed / Certified does not apply to your qualification path.
                                </FieldGroupHint>
                            )}
                            {isHygienistOrAssistant && (
                                <JobSeekingStatusContainer className="list-block inset">
                                    <JobSeekingStatusTitle>Job-Seeking Status</JobSeekingStatusTitle>
                                    <JobSeekingStatusDescription>
                                        Let dental offices know if you're actively looking for a permanent position when you send temp offers.
                                        This status will be visible to offices when you choose to share it.
                                    </JobSeekingStatusDescription>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <RadioOptionContainer 
                                            className={jobSeekingStatus === 0 ? 'selected' : ''}
                                            onClick={() => setJobSeekingStatus(0)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Radio 
                                                checked={jobSeekingStatus === 0}
                                                value={0}
                                                name="job-seeking-status"
                                                icon={<img id="circleUnchecked" className="hidden-icon" alt="" src={"img/circleUnchecked.svg"}/>}
                                                checkedIcon={<img id="circleChecked" className="hidden-icon" alt="" src={"img/circleChecked.svg"}/>}
                                                style={{ padding: '8px', marginRight: '8px', alignSelf: 'flex-start', marginTop: '2px' }}
                                            />
                                            <RadioLabelContainer>
                                                <RadioMainLabel>Temping only</RadioMainLabel>
                                                <RadioDescription>
                                                    Your job search status is private. You can choose Job Board alerts separately.
                                                </RadioDescription>
                                            </RadioLabelContainer>
                                        </RadioOptionContainer>

                                        <RadioOptionContainer 
                                            className={jobSeekingStatus === 1 ? 'selected' : ''}
                                            onClick={() => setJobSeekingStatus(1)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Radio 
                                                checked={jobSeekingStatus === 1}
                                                value={1}
                                                name="job-seeking-status"
                                                icon={<img id="circleUnchecked" className="hidden-icon" alt="" src={"img/circleUnchecked.svg"}/>}
                                                checkedIcon={<img id="circleChecked" className="hidden-icon" alt="" src={"img/circleChecked.svg"}/>}
                                                style={{ padding: '8px', marginRight: '8px', alignSelf: 'flex-start', marginTop: '2px' }}
                                            />
                                            <RadioLabelContainer>
                                                <RadioMainLabel>Actively looking for a position</RadioMainLabel>
                                                <RadioDescription>
                                                    Let offices know you are actively looking for a position.
                                                </RadioDescription>
                                            </RadioLabelContainer>
                                        </RadioOptionContainer>

                                        <RadioOptionContainer 
                                            className={jobSeekingStatus === 2 ? 'selected' : ''}
                                            onClick={() => setJobSeekingStatus(2)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Radio 
                                                checked={jobSeekingStatus === 2}
                                                value={2}
                                                name="job-seeking-status"
                                                icon={<img id="circleUnchecked" className="hidden-icon" alt="" src={"img/circleUnchecked.svg"}/>}
                                                checkedIcon={<img id="circleChecked" className="hidden-icon" alt="" src={"img/circleChecked.svg"}/>}
                                                style={{ padding: '8px', marginRight: '8px', alignSelf: 'flex-start', marginTop: '2px' }}
                                            />
                                            <RadioLabelContainer>
                                                <RadioMainLabel>Open to great opportunities</RadioMainLabel>
                                                <RadioDescription>
                                                    Let offices know you are open to a great opportunity.
                                                </RadioDescription>
                                            </RadioLabelContainer>
                                        </RadioOptionContainer>
                                    </div>
                                </JobSeekingStatusContainer>
                            )}
                            {!isHygienistOrAssistant ?
                            <div className="list-block inset inputBox">
                            <MaterialInput
                                className={'styledInput'}
                                label="School / Institute"
                                id={'education'}
                                name={"education"}
                                type={"text"}
                                onChange={schoolHandler}
                                error={!!errorMessage?.education}
                                    helperText={!!errorMessage?.education && errorMessage.education}
                                />
                            </div> : null}

                            {isHygienistOrAssistant ?
                            <div
                                className={clsx("roundedBox no-fastclick inset", isQualificationFilled === false && 'errorBox')}
                                onClick={openQualificationModal}
                            >
                                <div className="roundedBoxContent">
                                    <div>
                                        <GreenCheckmarkWithText
                                            isChecked={!!isQualificationFilled}
                                            header={'Qualification & Skills'}
                                            description={isQualificationFilled ? 'Completed' : 'Required'}
                                        />
                                        <div className="roundedBoxDescription">
                                            Let Dental Offices know about your specific training and skills
                                        </div>
                                    </div>
                                    <ChevronRightIcon className="chevronRightIcon"/>
                                </div>
                            </div> : null}
                            {isQualificationFilled === false && isHygienistOrAssistant ? (
                            <ErrorDescription>
                                Fill out your skills so we can show you all applicable jobs in your area.
                            </ErrorDescription>
                            ) : null}

                            <div
                                className={clsx("roundedBox no-fastclick inset")}
                                onClick={openPositionModal}
                            >
                                <div className="roundedBoxContent">
                                    <div>
                                        <GreenCheckmarkWithText
                                            isChecked={!!isWorkExperienceFilled}
                                            header={'Work Experience'}
                                            description={isWorkExperienceFilled ? 'Completed' : 'Optional but required later'}
                                        />
                                        <div className="roundedBoxDescription">
                                            Show Dental Offices your professional experience in the dental industry
                                        </div>
                                    </div>
                                    <ChevronRightIcon className="chevronRightIcon"/>
                                </div>
                            </div>

                            <div
                                className={clsx("roundedBox no-fastclick inset")}
                                onClick={openAboutModal}
                            >
                                <div className="roundedBoxContent">
                                    <div>
                                        <GreenCheckmarkWithText
                                            isChecked={!!isAboutFilled}
                                            header={'About You'}
                                            description={isAboutFilled ? 'Completed' : 'Optional'}
                                        />
                                        <div className="roundedBoxDescription">
                                            Write a bio or we can magically write one for you.
                                        </div>

                                    </div>
                                    <ChevronRightIcon className="chevronRightIcon"/>
                                </div>
                            </div>

                            <div className={'list-block inset inputBox bottomText'}>
                                Complete your profile so you can really shine & get access to those shifts and postings you really want!
                            </div>

                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                id="signup-button"
                                className="bigButtonInNewStyle"
                                type={'submit'}
                            >
                                Finish Sign Up
                            </Button>
                        </form>
                    </div>
                </div>

                <div className="footer">
                </div>
            </Container>
            <FixedLoader loading={ changeRoleLoading }/>
        </Page>
    )
}
